import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { GasSafe } from "@/components/GasSafe";
import { Areas } from "@/components/Areas";
import { Reviews } from "@/components/Reviews";
import { Footer } from "@/components/Footer";
import { MobileCTA } from "@/components/MobileCTA";
import { QuoteForm } from "@/components/QuoteForm";

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const openQuote = () => setQuoteOpen(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain" />
      <Toaster position="top-center" theme="dark" richColors />
      <Header onQuote={openQuote} />
      <main>
        <Hero onQuote={openQuote} />
        <Marquee />
        <Services onQuote={openQuote} />
        <Manifesto />
        <GasSafe />
        <Areas onQuote={openQuote} />
        <Reviews />
      </main>
      <Footer onQuote={openQuote} />
      <MobileCTA onQuote={openQuote} />
      <QuoteForm open={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </div>
  );
}

export default App;
